import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import isGHMC, { getCurrentDate, getCurrentDateTime, getStartOfCurrentDate } from '../../../Common/helper/helpar';
import * as XLSX from 'xlsx';
import CreatableSelect from 'react-select/creatable';
import ExcelJS from "exceljs";
import { getTrafficMarshalSummaryData } from '../../../Apis/TrafficMarshalReports/ReportsTrafficMarshal';
import { TableLoader } from '../../../Common/ShimmerLoader';
import { toast } from 'react-toastify';
import { AllVehicleTypeDetails } from '../../../Apis/vehicleApi';
import { AllOwnerTypeDetails } from '../../../Apis/ownerTypeApi';
const SummaryReports = () => {
  const isProd = isGHMC();
  const [currentPage, setCurrentPage] = useState(0);
  const [groupsPerPage, setGroupsPerPage] = useState(100); // Number of groups per page
  const [searchQuery, setSearchQuery] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [operationType, setOperationType] = useState("");
  const [dataLoading, setDataLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const formattedYesterday = yesterday.toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);


  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };
    console.log(selectedOwnerType, 'selectedowner')
    fetchOwnerTypeData();
  }, [selectedOwnerType]);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);

  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedOwnerType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  useEffect(() => {
    setOptionsValues(ownerTypeDetails
      .filter((ownerType) => ownerType.isActive)
      .map(ownerType => ({
        value: ownerType.ownerTypeId,
        label: ownerType.ownerTypeName,
      })));
  }, [ownerTypeDetails]);

  useEffect(() => {
    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);



  const fetchData = async () => {
    setDataLoading(true);
    try {
      const response = await getTrafficMarshalSummaryData(startDate, endDate, selectedVehicleType, selectedOwnerType);
      const responseData = response.data;
      setRows(responseData);
      setDataLoading(false);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
      console.error("Error fetching data:", error);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Filtered data based on the search query
  const filteredData = rows?.filter((row) => {
    return (
      (operationType === "" ||
        row?.operations?.some(
          (operation) => operation.operationType === operationType
        )) &&
      (vehicleNumber === "" ||
        row.vehicleNumber.toLowerCase().includes(vehicleNumber.toLowerCase()))
    );
  });


  const downloadAsExcel = async () => {
    const dataToUse = filteredData; // Data to use for generating the report
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Traffic Marshal Live Summary Report Generated on: ${formattedDate}, ${formattedTime}`;

    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Vehicle Data");

    // Define styles for headers and rows
    const boldFont = { bold: true };

    // Add the generated date and time to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply bold styling to the header cells
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add "Vehicle Data Report" header
    worksheet.addRow(["", "", "Vehicle Data Report", ""]);
    worksheet.mergeCells(2, 2, 2, 6);
    worksheet.getCell(2, 2).value = "Vehicle Data Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Add an empty row for spacing
    worksheet.addRow([""]);

    // Add the table header row
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle Number",
      "Transfer Station/SCTP",
      "Operation Type 1",
      "Vehicle Type",
      "Owner Type",
      "Traffic Marshal Name",
      "IN Time",
      "OUT Time",
      "SLA",
      "Duration (In Minutes)"
    ]);

    tableHeaderRow.eachCell((cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left-align text
      if (colNumber >= 1 && colNumber <= 11) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Background color for header
          bgColor: { argb: "FFFFFFFF" }, // White text color
        };
      }
    });

    let totalDuration = 0; // Initialize total duration counter
    let rowIndex = 5; // Start row index for data

    // Process each vehicle and its operations
    dataToUse.forEach((vehicle, index) => {
      let rowData = [
        index + 1, // Serial Number
        vehicle.vehicleNumber?? "N/A",
        vehicle.transferStation?? "N/A",
      ];

      let vehicleDuration = 0; // Store total duration for this vehicle
      let operationsProcessed = false;

      vehicle.operations.forEach((operation, opIndex) => {
        if (!operationsProcessed) {
          rowData.push(
            operation.operationType,
            operation.vehicleType,
            operation.ownerType,
            operation.trafficMarshalName,
            operation.inTime,
            operation.outTime,
            operation.duration
          );

          vehicleDuration += operation.duration;
          operationsProcessed = true;
        } else {
          if (opIndex === 1) {
            rowData.push(
              operation.operationType,
              operation.inTime,
              operation.outTime,
              operation.duration
            );
            vehicleDuration += operation.duration;
          }
        }
      });

      while (rowData.length < 10) {
        rowData.push(""); // Fill missing columns
      }

      rowData.push(vehicleDuration); // Add vehicle's total duration
      totalDuration += vehicleDuration; // Add to total duration sum

      // Add row to worksheet and enforce left-aligned text for all cells
      const dataRow = worksheet.addRow(rowData);
      dataRow.eachCell((cell) => {
        cell.alignment = { horizontal: "left" };
      });

      rowIndex++;
    });

    // Add the total duration row at the bottom
    const totalRow = worksheet.addRow([
      "", "", "", "", "", "", "", "", "", "Total ", totalDuration
    ]);

    // Apply bold styling and left alignment for the total row
    totalRow.eachCell((cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: colNumber === 10 ? "right" : "left" };
      if (colNumber >= 9) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Yellow highlight for total
        };
      }
    });

    // Set column widths dynamically
    worksheet.columns = [
      { width: 10 },   // S.No
      { width: 20 },   // Vehicle Number
      { width: 25 },   // Transfer Station/SCTP
      { width: 20 },   // Operation Type 1
      { width: 15 },   // Vehicle Type
      { width: 15 },   // Owner Type
      { width: 25 },   // Traffic Marshal Name
      { width: 15 },   // IN Time 1
      { width: 15 },   // OUT Time 1
      { width: 15 },   // SLA
      { width: 20 },   // Duration (Minutes)
    ];

    // Generate the Excel file and trigger download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TrafficMarshalSummaryReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const totalGroups = filteredData.length;

  // Calculate the groups to display on the current page
  const indexOfFirstGroup = currentPage * groupsPerPage;
  const currentGroups = filteredData.slice(indexOfFirstGroup, indexOfFirstGroup + groupsPerPage);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleGroupsPerPageChange = (event) => {
    setGroupsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset to first page when changing groups per page
  };


  const headerStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#004554" : "#EC1117", }
  const cellStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', whiteSpace: "normal" };
  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    const start = new Date(startDate);
    const end = new Date(newEndDate);

    if (!startDate || isNaN(start)) {
      alert("Please select a valid start date first.");
      return;
    }

    const maxEndDate = new Date(start);
    maxEndDate.setDate(start.getDate() + 7);

    if (end >= start && end <= maxEndDate && end <= new Date(getCurrentDateTime())) {
      setEndDate(newEndDate);
    } else {
      alert("End date must be within 7 days of the start date.");
    }
  };


  return (
    <div className="content">
      <div className="page-content">
        <h4 class="text-start mb-3">Summary Report</h4>
        <div className="card">
          <div className="card-body p-3">
            <div className="row align-items-end text-start">
              <div className="col-md-2">
                <label>Start Date:</label>
                {/* <input
                  type="datetime-local"
                  name="FromDate"
                  className="form-control"
                  style={inputStyle}
                  value={startDate || ""}
                  max={getCurrentDateTime()}
                  onChange={(e) => {
                    const newStartDate = e.target.value;

                    if (!newStartDate) {
                      setStartDate("");
                      return;
                    }

                    const validStartDate = new Date(newStartDate);
                    if (isNaN(validStartDate)) {
                      console.error("Invalid start date:", newStartDate);
                      return;
                    }

                    setStartDate(newStartDate);

                    // Ensure end date remains valid if already set
                    if (endDate) {
                      const currentEndDate = new Date(endDate);
                      const maxEndDate = new Date(validStartDate);
                      maxEndDate.setDate(validStartDate.getDate() + 7);

                      if (currentEndDate > maxEndDate) {
                        setEndDate(maxEndDate);
                      }
                    }
                  }}
                /> */}

                <input
                  type="datetime-local"
                  name="FromDate"
                  className="form-control"
                  style={inputStyle}
                  value={startDate}
                  max={endDate ? endDate : getCurrentDate()}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>

              <div className="col-md-2">
                <label>End Date:</label>
                <input
                  type="datetime-local"
                  name="ToDate"
                  style={inputStyle}
                  value={endDate}
                  className="form-control"
                  min={startDate}
                  max={getCurrentDateTime()} // Earliest date selectable is the start date
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>

              <div className="col-md-2">
                <label htmlFor="ownerType">Owner Type:</label>
                <CreatableSelect
                  classNamePrefix="CreatableSelect"
                  inputId="ownerType"
                  name="ownerTypeId"
                  id="ownerType"
                  placeholder="Select"
                  options={optionsValues}
                  isClearable={true}
                  onChange={handleChange}
                  onCreateOption={(inputValue) => {
                    const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                    if (inputValue) {
                      setSelectedOwnerType(newValue.value);
                      setOptionsValues((prevOptions) => [...prevOptions, newValue]);
                    } else {
                      setSelectedOwnerType("");
                    }
                  }}
                  value={optionsValues.find((option) => option.value === selectedOwnerType)}
                //  className="hidden-select" // Apply the custom class here
                />
              </div>
              <div className="col-md-2">
                <label htmlFor="VehicleType">Vehicle Type:</label>
                <CreatableSelect style={{ Height: '34px !important' }}
                  classNamePrefix="CreatableSelect"
                  inputId="vehicleType"
                  name="vehicleTypeId"
                  id="vehicleType"
                  placeholder="Select"
                  options={vehicleTypeOptionsValues}
                  isClearable={true}
                  onChange={handleVehicleTypeChange}
                  onCreateOption={(inputValue) => {

                    const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                    { inputValue && newValue ? (setSelectedVehicleType(newValue.value)) : setSelectedVehicleType("  "); }
                    // setSelectedOwnerType(newValue.value);
                    // Add logic to update optionsValues with the new option if needed
                  }}
                  value={vehicleTypeOptionsValues.find((option) => option.value === selectedVehicleType)}
                />
              </div>
              <div className="col-md-4 d-flex justify-content-between">
                <button
                  onClick={fetchData}
                  className={`btn  ${isProd ? "search-ghmc" : "search-swm"}`}
                >
                  Search
                </button>

                <button
                  className="btn btn-excel ms-auto"
                  onClick={downloadAsExcel}
                >
                  <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                </button>
              </div>
            </div>
            <div className='table-responsive'>
              {dataLoading ? <TableLoader height={500} /> :
                <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '20px' }}>
                  <TableContainer
                    component={Paper}
                    sx={{
                      width: '100%',
                      maxHeight: '500px',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Table>
                      <TableHead
                        sx={{
                          position: 'sticky',
                          top: 0,
                          zIndex: 0, // Ensure header stays above other content
                        }}
                      >
                        <TableRow sx={{ paddingTop: '20px' }}>
                          <TableCell sx={headerStyles}>S.No</TableCell>
                          <TableCell sx={headerStyles}>Vehicle Number</TableCell>
                          <TableCell sx={headerStyles}>Transfer Station/SCTP</TableCell>
                          <TableCell sx={headerStyles}>Operation Type</TableCell>
                          <TableCell sx={headerStyles}>Vehicle Type</TableCell>
                          <TableCell sx={headerStyles}>Owner Type</TableCell>
                          <TableCell sx={headerStyles}>Traffic Marshal Name</TableCell>
                          <TableCell sx={headerStyles}>IN Time</TableCell>
                          <TableCell sx={headerStyles}>Out Time</TableCell>
                          <TableCell sx={headerStyles}>SLA</TableCell>
                          <TableCell sx={headerStyles}>Duration (In Minutes)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentGroups.length > 0 ? currentGroups.map((vehicle, groupIndex) => (
                          <React.Fragment key={groupIndex}>
                            {vehicle.operations.map((operation, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  backgroundColor: index % 2 === 1 ? 'rgba(0, 69, 84, 0.04)' : '#ffffff',
                                  '&:nth-of-type(odd)': { backgroundColor: '#ffffff' },
                                  '&:nth-of-type(even)': { backgroundColor: 'rgba(0, 69, 84, 0.04)' },
                                }}
                              >
                                <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>{index + 1}</TableCell>
                                <TableCell sx={cellStyles}>{vehicle.vehicleNumber || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{vehicle.transferStation || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.operationType || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.vehicleType || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.ownerType || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.trafficMarshalName || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.inTime || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.outTime || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.sla || "N/A"}</TableCell>
                                <TableCell sx={cellStyles}>{operation.duration || "N/A"}</TableCell>
                              </TableRow>
                            ))}
                            <TableRow>
                              <TableCell style={{ fontWeight: "bold", textAlign: "Right" }} sx={cellStyles} colSpan={10}>Total</TableCell>
                              <TableCell style={{ fontWeight: "bold" }} sx={cellStyles}>
                                {vehicle.operations.reduce((acc, operation) => acc + operation.duration, 0)} minutes
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        )) : (
                          <TableCell colSpan={9} sx={cellStyles}>No data</TableCell>
                        )
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    component="div"
                    count={totalGroups}
                    page={currentPage}
                    onPageChange={handlePageChange}
                    rowsPerPage={groupsPerPage}
                    onRowsPerPageChange={handleGroupsPerPageChange}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    labelRowsPerPage="Groups per page"
                  />
                </Paper>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryReports;

const inputStyle = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};
